import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

// Top-level vangnet: voorkomt een wit scherm bij een render-fout ergens in de app.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Log in correlation-stijl zodat het terug te vinden is in de console.
    // eslint-disable-next-line no-console
    console.error('[ui-error]', error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50 px-6 text-center"
          data-testid="app-error-boundary"
        >
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-amber-100">
            <AlertTriangle className="text-amber-600" size={28} />
          </div>
          <h1 className="text-xl font-semibold text-slate-800">Er ging iets mis</h1>
          <p className="max-w-sm text-sm text-slate-500">
            Er trad een onverwachte fout op in de weergave. Herlaad de pagina om verder te gaan.
            Blijft het probleem terugkomen, neem dan contact op met de beheerder.
          </p>
          <button
            onClick={() => window.location.reload()}
            data-testid="app-error-reload"
            className="inline-flex items-center gap-2 rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-slate-700"
          >
            <RefreshCw size={16} /> Pagina herladen
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
